import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
// import { Helmet } from "react-helmet";

import TemplateXSNows from "Components/Templates/XSNows";
import TemplateNows from "Components/Templates/Nows";

import * as styles from "styles";
import * as Types from "Types";
import * as enums from "enumerations";
import * as actions from "actions";

export default function Nows() {
   const width = useSelector(({ dimensions }: Types.State) => dimensions.width);
   const location = useLocation();
   const dispatch = useDispatch();

   console.log("location", location);

   dispatch({ type: actions.nows.get.call });

   return (
      <>
         {/* <Helmet>
            <title>NOW - 아트맵</title>
            <meta
               name="description"
               content="전시회, 보고는 싶은데 시작부터 막막하다면? 아트맵이 다 골라왔으니 누르기만 하세요! 지금 인기 있는 전시회부터 지역별, 장르별, 무료 전시회까지. 똑똑한 문화생활, 아트맵과 함께 하세요. "
            />
            <meta name="og:title" content="NOW - 아트맵" />
            <meta
               name="og:description"
               content="전시회, 보고는 싶은데 시작부터 막막하다면? 아트맵이 다 골라왔으니 누르기만 하세요! 지금 인기 있는 전시회부터 지역별, 장르별, 무료 전시회까지. 똑똑한 문화생활, 아트맵과 함께 하세요. "
            />
            <meta name="og:keywords" content="전시관,갤러리,미술관,전시회,예술,아트,미술,서울,부산,대구,제주" />
            <meta name="og:image" content="https://art-map.co.kr/img/main/logo_black.png" />
         </Helmet> */}
         {styles.getGridSize(width) === enums.grid.sizes.xs ? <TemplateXSNows></TemplateXSNows> : <TemplateNows></TemplateNows>}
      </>
   );
}
